module.exports = __webpack_public_path__ + "static/img/marmalade_pictgrid7_800x783.c1b6cc3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/marmalade_pictgrid7_800x783.jpg
// module id = uIHN
// module chunks = 0